import * as appConstant from "../../constants/appConstant";

import ValidationIcon from "./ValidationIcon";

import {
    averageBaselineRevenueValidation,
    baselineCalculatedValidation,
    dateValidation,
    maxCharacterValidation,
    nonNegativeNumericValidation,
    numericValidation,
    optionListValidation
} from "./Validation/validationFunctions";

export const ADVERTISER_CID_LABEL = "Advertiser CID";
export const PLACEMENT_STATUS_LABEL = "Placement Status";
export const PLACEMENT_START_DATE_LABEL = "Start Date & Time";
export const PLACEMENT_END_DATE_LABEL = "End Date & Time";
export const PLACEMENT_TYPE_LABEL = "Placement Type [Location]";
export const PLACEMENT_NAME = "Placement Name";
export const ORIGINAL_PUBLISHER_COMMISSION_LABEL = "Original Publisher Commission (%)";
export const NEW_PUBLISHER_COMMISSION_LABEL = "New Publisher Commission (%)";
export const ORIGINAL_FLAT_FEE_LABEL = "Original/Rate Card Flat Fee Cost";
export const CJ_FLAT_FEE_LABEL = "Negotiated Flat Fee Cost";
export const PERSONALIZED_TARGETED_LABEL = "Personalized/Targeted Offer";
export const DYNAMIC_STATIC_LABEL = "Dynamic vs. Static Placement Type";
export const RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD = "Placement Spot/Position";
export const EVENTS_LABEL = "Events";
export const SEND_SIZE_LABEL = "Send Size, Expected Unique Views";
export const PACKAGE_NAME_LABEL = "Package Name";
export const NEW_OR_COMPED_LABEL = "Comped (Compared to) Last Year or New";
export const VIP_CONTENT_LABEL = "VIP Content Campaign";
export const PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD = "Proposed Ad Copy";
export const SOV_BEFORE_LABEL = "Share Of Voice Pre-Placement (%)";
export const ACTUAL_SOV_AFTER_LABEL = "Share of Voice Post-Placement (%)";
export const YOY_GROWTH_TREND_LABEL = "Organic Lift Over Baseline (%)";
export const PRIOR_PLACEMENT_LIFT_LABEL = "Expected Placement Lift Over Baseline (%)";
export const OTHER_EXPECTED_LIFT_LABEL = "Other Lift Over Baseline e.g. Sale (%)";
export const TIERED_OFFER_LABEL = "Tiered Offer Details";
export const OFFER_TYPE_LABEL = "Offer Type";
export const OFFER_VALUE_LABEL = "Offer Value";
export const OFFER_CONDITIONS_LABEL = "Offer Conditions";
export const OFFER_THRESHOLD_LABEL = "Offer Threshold";
export const LINK_ID_LABEL = "Link ID";
export const ASSETS_NEEDED_LABEL = "Assets Needed";
export const ASSET_DUE_DATE_LABEL = "Asset Due Date";
export const ASSETS_SENT_BY_ADVERTISER_LABEL = "Assets Sent By Advertiser";
export const CJ_MARKETPLACE_IO_LABEL = "CJ Marketplace IO#";
export const PUBLISHER_IO_LABEL = "Publisher IO#";
export const IO_SIGNED_LABEL = "IO Signed?";
export const PROGRAM_TERM_NAME_LABEL = "Program Term Name";
export const PROGRAM_TERM_PUSHED_LABEL = "Has Program Term Been Pushed?";
export const CASHBACK_AMOUNT_ONSITE_LABEL = "Cashback/Incentive Amount";
export const PUBLISHER_USED_LINK_ID_LABEL = "Publisher Used Specified Link ID";
export const OFFER_DESCRIPTION_TEXT_LABEL = "Live Ad Copy on Publisher Property";
export const PATH_TO_SAVED_EMAIL_LABEL = "Path for Screenshot/Email";
export const VALIDATION_NOTES_LABEL = "Validation Notes";
export const PAID_IN_CJ_LABEL = "Paid in CJ?";
export const PAYMENT_DATE_LABEL = "Payment Date";
export const PAYMENT_OID_LABEL = "Payment OID / Transaction ID";
export const AMOUNT_PAID_LABEL = "Amount Paid";
export const PAYMENT_NOTES_LABEL = "Payment Notes";
export const AVERAGE_DAILY_REVENUE_BASELINE_LABEL = "Average Daily Revenue Baseline";
export const PROGRAM_TERM_DESCRIPTION_LABEL = "Program Term Description";
export const FISCAL_YEAR_LABEL = "Fiscal Year";
export const FISCAL_QUARTER_LABEL = "Fiscal Quarter";
export const FISCAL_MONTH_LABEL = "Fiscal Month";
export const FISCAL_WEEK_LABEL = "Fiscal Week";
export const PUBLISHER_PROPERTY_ID_LABEL = "Publisher Property ID";
export const USE_AUTO_CALCULATED_BASELINE_LABEL = "Use Auto-Calculated Baseline";
export const CJ_INVOICE_MONTH_LABEL = "CJ Invoice Month";

export const BULK_UPLOAD = "BULK UPLOAD";
export const UPLOAD_PLACEMENT_BUTTON_LABEL = 'UPLOAD PLACEMENTS';

export const BULK_UPLOAD_ERROR_MESSAGE = {
    placementStatusId: "Mandatory field Placement Status is blank",
    advertiserCompanyId: 'Mandatory field Advertiser CID is blank',
    placementName: 'Mandatory field Placement Name is blank',
    publisherPropertyId: 'Mandatory field Publisher Property ID is blank',
    placementType: 'Mandatory field Placement Type [Location] is blank',
    dynamicOrStatic: 'Mandatory field Dynamic vs. Static Placement Type is blank',
    personalizedOrTargeted: 'Mandatory field Personalized/Targeted Offer is blank',
    newOrComped: 'Mandatory field Comped (Compared to) Last Year or New is blank',
    vipContentCampaign: 'Mandatory field VIP Content Campaign is blank',
    pStartDate: 'Mandatory field Start Date & Time is blank',
    pEndDate: 'Mandatory field End Date & Time is blank',
    bookingmarketinsertionorder: 'Mandatory field CJ Marketplace IO is blank',
    bookingotherio: 'Mandatory field Publisher IO is blank',
    performanceOriginalPublisherCommission: 'Mandatory field Original Publisher Commission (%) is blank',
    isBaselineCalculated: 'Mandatory field Use Auto-Calculated Baseline is blank',
    averageBaselineRevenue: 'Mandatory field Average Daily Revenue Baseline is blank',
    invalidBaselineCalculated: 'Invalid Use Auto-Calculated Baseline',
    invalidAverageBaselineRevenue: 'Average Daily Revenue Baseline must be provided if and only if Use Auto-Calculated is No',
    negativeAverageBaselineRevenue: 'Average Daily Revenue Baseline accepts 0 or a positive number (without special characters)'
};

export const BULK_UPLOAD_DATATABLE_COLUMNS = [
    {
        field: "placementStatusId",
        headerName: PLACEMENT_STATUS_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.PLACEMENT_STATUS_FIELD},
        errorMessage: 'Invalid Placement Status'
    },
    {
        field: "advertiserCompanyId.value",
        headerName: ADVERTISER_CID_LABEL,
    },
    {
        field: "pid.publisherPropertyId",
        headerName: PUBLISHER_PROPERTY_ID_LABEL,
        validation: numericValidation,
        errorMessage: 'Invalid Publisher Property ID'
    },
    {
        field: "pStartDate",
        headerName: PLACEMENT_START_DATE_LABEL,
    },
    {
        field: "pEndDate",
        headerName: PLACEMENT_END_DATE_LABEL,
    },
    {
        field: "fiscalYear",
        headerName: FISCAL_YEAR_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Fiscal Year exceeds maximum length'
    },
    {
        field: "fiscalQuarter",
        headerName: FISCAL_QUARTER_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Fiscal Quarter exceeds maximum length'
    },
    {
        field: "fiscalMonth",
        headerName: FISCAL_MONTH_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Fiscal Month exceeds maximum length'
    },
    {
        field: "fiscalWeek",
        headerName: FISCAL_WEEK_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Fiscal Week exceeds maximum length'
    },
    {
        field: "placementName",
        headerName: PLACEMENT_NAME,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 1000},
        errorMessage: 'Placement Name exceeds maximum length'
    },
    {
        field: "placementType",
        headerName: PLACEMENT_TYPE_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.PLACEMENT_TYPE},
        errorMessage: 'Invalid Placement Type [Location]'
    },
    {
        field: "dynamicOrStatic",
        headerName: DYNAMIC_STATIC_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.DYNAMIC_OR_STATIC_FIELD},
        errorMessage: 'Invalid Dynamic vs. Static Placement Type'
    },
    {
        field: "personalizedOrTargeted",
        headerName: PERSONALIZED_TARGETED_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.YES_NO_OPTION},
        errorMessage: 'Invalid Personalized/Targeted Offer'
    },
    {
        field: "newOrComped",
        headerName: NEW_OR_COMPED_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.NEW_OR_COMPED_FIELD},
        errorMessage: 'Invalid Comped (Compared to) Last Year or New'
    },
    {
        field: "vipContentCampaign",
        headerName: VIP_CONTENT_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.YES_NO_OPTION},
        errorMessage: 'Invalid VIP Content Campaign'
    },
    {
        field: "events",
        headerName: EVENTS_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.EVENTS},
        errorMessage: 'Invalid Events'
    },
    {
        field: "packageName",
        headerName: PACKAGE_NAME_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 200},
        errorMessage: 'Package Name exceeds maximum length'
    },
    {
        field: "rankofplacement",
        headerName: RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Placement Spot/Position accepts 0 or a positive number (without special characters)'
    },
    {
        field: "proposedOfferDescription",
        headerName: PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Proposed Ad Copy exceeds maximum length'
    },
    {
        field: "performanceDetails.performanceOriginalPublisherCommission",
        headerName: ORIGINAL_PUBLISHER_COMMISSION_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Original Publisher Commission (%) accepts 0 or a positive number (without special characters)'
    },
    {
        field: "performanceDetails.performanceNewPublisherCommission",
        headerName: NEW_PUBLISHER_COMMISSION_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'New Publisher Commission (%) accepts 0 or a positive number (without special characters)'
    },
    {
        field: "performanceDetails.performanceOriginalRateCardFlatFeePrice",
        headerName: ORIGINAL_FLAT_FEE_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Original/Rate Card Flat Fee Cost accepts 0 or a positive number (without special characters)'
    },
    {
        field: "performanceDetails.performanceCjNegotiatedFlatFeeCost",
        headerName: CJ_FLAT_FEE_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Negotiated Flat Fee Cost accepts 0 or a positive number (without special characters)'
    },
    {
        field: "performanceDetails.baselineValue.isBaselineCalculated",
        headerName: USE_AUTO_CALCULATED_BASELINE_LABEL,
        validation: baselineCalculatedValidation,
        validationArgs: {acceptedValues: appConstant.YES_NO_OPTION}
    },
    {
        field: "performanceDetails.baselineValue.averageBaselineRevenue",
        headerName: AVERAGE_DAILY_REVENUE_BASELINE_LABEL,
        validation: averageBaselineRevenueValidation
    },
    {
        field: "performanceDetails.performanceyoygrowthtrendused",
        headerName: YOY_GROWTH_TREND_LABEL,
        validation: numericValidation,
        errorMessage: 'Organic Lift Over Baseline (%) accepts number (without special characters)'
    },
    {
        field: "performanceDetails.performancePredictedPlacementLift",
        headerName: PRIOR_PLACEMENT_LIFT_LABEL,
        validation: numericValidation,
        errorMessage: 'Expected Placement Lift Over Baseline (%) accepts number (without special characters)'
    },
    {
        field: "performanceDetails.performanceOtherExpectedLift",
        headerName: OTHER_EXPECTED_LIFT_LABEL,
        validation: numericValidation,
        errorMessage: 'Other Lift Over Baseline e.g. Sale (%) accepts number (without special characters)'
    },
    {
        field: "performanceDetails.performanceSendSizeExpectedUniqueValues",
        headerName: SEND_SIZE_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Send Size, Expected Unique Views accepts 0 or a positive number (without special characters)'
    },
    {
        field: "performanceDetails.performanceSovBefore",
        headerName: SOV_BEFORE_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Share Of Voice Pre-Placement (%) accepts 0 or a positive number (without special characters)'
    },
    {
        field: "performanceDetails.performanceActualSovAfter",
        headerName: ACTUAL_SOV_AFTER_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Share of Voice Post-Placement (%) accepts 0 or a positive number (without special characters)'
    },
    {
        field: "bookingdetails.bookingmarketinsertionorder",
        headerName: CJ_MARKETPLACE_IO_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 200},
        errorMessage: 'CJ Marketplace IO# exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingotherio",
        headerName: PUBLISHER_IO_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 200},
        errorMessage: 'Publisher IO# exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingissigned",
        headerName: IO_SIGNED_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.YES_NO_NA_OPTION},
        errorMessage: 'Invalid IO Signed?'
    },
    {
        field: "bookingdetails.bookingprogramtermdescription",
        headerName: PROGRAM_TERM_DESCRIPTION_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Program Term Description exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingprogramtermname",
        headerName: PROGRAM_TERM_NAME_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Program Term Name exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingispushed",
        headerName: PROGRAM_TERM_PUSHED_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.FLAT_FEE_OPTION},
        errorMessage: 'Invalid Has Program Term Been Pushed?'
    },
    {
        field: "bookingdetails.bookingduedate",
        headerName: ASSET_DUE_DATE_LABEL,
        validation: dateValidation,
        errorMessage: 'Invalid Asset Due Date',
        validationArgs: {
            dateFormat: appConstant.DATE_TIME_FORMAT
        }
    },
    {
        field: "bookingdetails.bookingassetsneeded",
        headerName: ASSETS_NEEDED_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Assets Needed exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingassetsentdate",
        headerName: ASSETS_SENT_BY_ADVERTISER_LABEL,
        validation: dateValidation,
        validationArgs: {
            dateFormat: appConstant.DATE_TIME_FORMAT
        },
        errorMessage: 'Invalid Assets Sent By Advertiser'
    },
    {
        field: "bookingdetails.bookingtieredoffer",
        headerName: TIERED_OFFER_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Tiered Offer Details exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingoffertype",
        headerName: OFFER_TYPE_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.OFFER_TYPE_FIELD},
        errorMessage: 'Invalid Offer Type'
    },
    {
        field: "bookingdetails.bookingoffervalue",
        headerName: OFFER_VALUE_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 200},
        errorMessage: 'Offer Value exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingoffercondition",
        headerName: OFFER_CONDITIONS_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.OFFER_CONDITION_FIELD},
        errorMessage: 'Invalid Offer Conditions'
    },
    {
        field: "bookingdetails.bookingofferthreshold",
        headerName: OFFER_THRESHOLD_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Offer Threshold exceeds maximum length'
    },
    {
        field: "bookingdetails.bookingincentiveamount",
        headerName: CASHBACK_AMOUNT_ONSITE_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 200},
        errorMessage: 'Cashback/Incentive Amount exceeds maximum length'
    },
    {
        field: "bookingdetails.bookinglinkid",
        headerName: LINK_ID_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 200},
        errorMessage: 'Link ID exceeds maximum length'
    },
    {
        field: "bookingdetails.bookinginvoicemonth",
        headerName: CJ_INVOICE_MONTH_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'CJ Invoice Month exceeds maximum length'
    },
    {
        field: "validationDetails.publisherusedspecifiedlinkid",
        headerName: PUBLISHER_USED_LINK_ID_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.YES_NO_NA_OPTION},
        errorMessage: 'Invalid Publisher Used Specified Link ID'
    },
    {
        field: "validationDetails.wascorrectofferused",
        headerName: appConstant.CORRECT_OFFER_USED_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.YES_NO_NA_OPTION},
        errorMessage: 'Invalid Was Correct Offer Used in Placement'
    },
    {
        field: "validationDetails.description",
        headerName: OFFER_DESCRIPTION_TEXT_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Live Ad Copy on Publisher Property exceeds maximum length'
    },
    {
        field: "validationDetails.screenshotlink",
        headerName: PATH_TO_SAVED_EMAIL_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Path for Screenshot/Email exceeds maximum length'
    },
    {
        field: "validationDetails.validationnotes",
        headerName: VALIDATION_NOTES_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Validation Notes exceeds maximum length'
    },
    {
        field: "paymentDetails.paidInCJ",
        headerName: PAID_IN_CJ_LABEL,
        validation: optionListValidation,
        validationArgs: {acceptedValues: appConstant.PAID_IN_CJ_OPTION},
        errorMessage: 'Invalid Paid in CJ?'
    },
    {
        field: "paymentDetails.transactionid",
        headerName: PAYMENT_OID_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 500},
        errorMessage: 'Payment OID / Transaction ID exceeds maximum length'
    },
    {
        field: "paymentDetails.amount",
        headerName: AMOUNT_PAID_LABEL,
        validation: nonNegativeNumericValidation,
        errorMessage: 'Amount Paid accepts 0 or a positive number (without special characters)'
    },
    {
        field: "paymentDetails.transactiondate",
        headerName: PAYMENT_DATE_LABEL,
        validation: dateValidation,
        validationArgs: {dateFormat: appConstant.YYYY_MM_DD},
        errorMessage: 'Invalid Payment Date'
    },
    {
        field: "paymentDetails.notes",
        headerName: PAYMENT_NOTES_LABEL,
        validation: maxCharacterValidation,
        validationArgs: {maxLength: 4000},
        errorMessage: 'Payment Notes exceeds maximum length'
    }
];

export const TEMPLATE_ROW_ONE = ["Please review all the details in rows 1 - 9. Do not delete these rows and start adding placement records from row. no. 10, column B onwards."];
export const TEMPLATE_ROW_THREE = ["Category", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Details", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Cost & Proj. Lift", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Booking", "Validation", "Validation", "Validation", "Validation", "Validation", "Payment", "Payment", "Payment", "Payment", "Payment"];
export const TEMPLATE_ROW_FOUR = ["Definition", "Current status of the placement", "Advertiser/Client Company ID", "Publisher Property ID/Website ID", "Placement start date & time (in Advertiser's Preferred Reporting Timezone)", "Placement end date & time (in Advertiser's Preferred Reporting Timezone)", "Fiscal year in which the placement ran or is scheduled to run", "Fiscal quarter in which the placement ran or is scheduled to run", "Fiscal month in which the placement ran or is scheduled to run", "Fiscal week in which the placement ran or is scheduled to run", "Name of the placement", "The type/location of the placement", "Dynamic: Media placement within a rotation on pub site. Static: Media placement does not rotate among other placements on the site.", "Will the placement only be sent to/shown to a specific group of customers/shoppers?", "Indicate whether this same placement was run last year, or if it's new to the Advertiser", "Indicates if the placement is a VIP Content Campaign", "Placement is booked/proposed for a specific event e.g., on Father's Day", "Can be used to categorize the placement as part of a package, OR for any other categorization needed by the Adv (e.g. new product launch, client event, etc.)", "The booked/proposed spot or position of the placement on the website/newsletter/email", "Offer description", "Commission rate live before the placement starts OR publisher's default commission rate with this Advertiser", "New commission rate negotiated for the placement run dates", "Original/un-negotiated Flat Fee Rate offered by publisher or Rate Card Rate", "Flat fee price of the placement negotiated by CJ (if lower than the Original/Rate Card Flat Fee Cost)", "Indicates if the baseline used is the auto calculated one", "Average daily revenue without placement for that publisher (from the same month last year if auto-calculated baseline is used. If custom baseline is used, the user decides what timeframe the average daily revenue baseline is from.)", "Organic lift input by user to be used in projected KPI calculations", "The actual performance lift % observed from prior placement performance. This is required to run projections for the proposed placement.", "Use this field to isolate lift to due seasonality or other factors. This value will be incorporated into the projected KPI calculations", "Send Size: Audience size for a newsletter. UVs: Unique Visits - can request from publisher or use SimilarWeb", "Advertiser Share of Voice with that publisher prior to running the placement", "Advertiser Share of Voice with that publisher after running the placement", "IO (Insertion Order) Number from CJ Marketplace", "IO (Insertion Order) Number on the publisher's version of the IO", "Status of the IO execution (has it been signed by both parties)", "Decription of the Program Term the publisher should be on during the placement days", "Exact name of the Program Term the publisher should be on during the placement days", "Status of whether the program term has been pushed", "Last date for the submission of placement assets, dictated by each publisher via email/IO", "Detail what type of assets are needed for the placement, as dictated by the publisher via email/IO (Offer, Text Link or Banner/Image | for Banners - lifestyle or product image? Include client logo? Included call-to-action?)", "The date when Advertiser sent the assets", "Explain the details of the tiered/spend-more-save-more offer", "The type of offer that is being used for this placement", "The value of the Offer Type. For 25% Off, the Offer Value will be 25.", "Specific conditions that must be met in order for the Offer to apply", "The minimum order value for the offer to apply", "Cashback/Incentive amount that the consumer will see on the publisher's property", "Link ID to be used for the placement given to publisher (if needed/if agreed to)", "For invoiced clients: the month in which the placement flat fee will be charged to the Advertiser by CJ on the CJ invoice", "Has the pub used the link ID agreed to by both parties for this placement", "Track if correct offer was used", "Offer text found live on the publisher's property when audit was performed", "Where to find stored screenshots of placements", "Notes taken while auditing live placements. Can be used to indicate steps taken when the wrong offer or cashback/incentive was showing on the publisher property", "Status of the publisher payment", "OID for bonus payments & Transaction ID if paid from Placements Marketplace", "Amount paid toward the placement flat fee", "Date on which the last payment was made for the placement", "Notes about the payment(s) that have been made for the placement. It could include details of the currency conversion rate, if applicable."];
export const TEMPLATE_ROW_FIVE = ['Mandatory', "Yes", "Yes", "Yes", "Yes", "Yes", "No", "No", "No", "No", "Yes", "Yes", "Yes", "Yes", "Yes", "Yes", "No", "No", "No", "No", "Yes", "No, but if placement involves a CPA increase and this field is left blank, it will impact projections & in turn the actual incremental values & forecast accuracy.", "No, but if placement cost includes a flat fee, please provide either the original or the negotiated cost or both. If both fields are left blank, it will impact the performance KPIs like projected spends, actual total spend, ROAS, incremental values, forecast accuracy etc.", "No, but if placement cost includes a flat fee, please provide either the original or the negotiated cost or both. If both fields are left blank, it will impact the performance KPIs like projected spends, actual total spend, ROAS, incremental values and forecast accuracy etc.",
    "Yes", "Mandatory if Use Auto-Calculated Baseline is 'No'", "No, but if left blank will impact projections", "No, but if left blank will impact projections", "No, but if left blank will impact projections", "No", "No", "No", "Mandatory if flat fee is present & status is Booked", "Mandatory if flat fee is present & status is Booked", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No", "No"];
export const TEMPLATE_ROW_SIX = ["Instructions, Accepted Values & Format", "Accepted Values are Booked, Proposed, Declined",
    "Please provide a valid Advertiser CID. Only one advertiser CID can be present in the file. If you wish to upload placements for multiple advertiser CIDs, please break it out into multiple files (one for each CID).",
    "Please provide a valid Publisher Property ID. Make sure that this is the revenue-generating PID on which the placement will run.",
    "1. Date Format should be 'YYYY-MM-DD HH:MM:SS' (24 Hr) 2. End Date should be greater than the Start Date",
    "1. Date Format should be 'YYYY-MM-DD HH:MM:SS' (24 Hr) 2. End Date should be greater than the Start Date",
    "Max. length of 500 characters", "Max. length of 500 characters", "Max. length of 500 characters", "Max. length of 500 characters",
    "Max. length of 1000 characters", "Accepted Values are App Push, Article Inclusion, Cashback Event, Category Leader, Category Page, Content, Content - Dedicated Review, Content - Editorial, Content - Gift Guide, Content - Multi Merchant Review,  Coupon Page, Deal Page, Double Cashback, Footer Ads,  Homepage, Homepage - Search Keywords, Homepage Carousel, Loyalty, Make Good, Mobile App, Mobile Messaging, Mobile Webpage, Multi-Merchant Email, Package, Pop-Up Ads, Search, Seasonal Event Page, Social Media - Facebook,  Social Media - Google+, Social Media - Instagram, Social Media - Snapchat, Social Media - TikTok, Social Media - Twitter, Social Media - WeChat, Social Media - Weibo, Social Media - Youtube, Social Media - Others, Solo Email, Sponsored, Staff Picks, Store Page Category, Widget, Other",
    "Accepted Values are Static, Dynamic", "Accepted Values are Yes, No", "Accepted Values are Comped, New", "Accepted Values are Yes, No",
    "Accepted Values are August Bank Holiday, Back to School, Black Friday, Blue Monday (January), Boxing Day, Cheltenham Festival, Christmas, Cyber Monday, Cyber/Giving Tuesday, Early May Bank Holiday, Easter, FA Cup, Father's Day, Grand National, Halloween, Holiday, Independence Day, Labor Day, Late May Bank Holiday, Lunar New Year, Memorial Day, Mother's Day, New Year, President's Day, Product Launch, Single's Day, St Patrick's Day, Super Bowl, Tax Season, Thanksgiving, Valentine's Day, Wimbledon, World Cup",
    "Max. length of 200 characters", "Please provide the number only. Do not include any special characters.", "Max. length of 500 characters",
    "Please provide the number only. If commission is 30%, provide 30. Do not enter 0.30 or 30%. ", "Please provide the number only. If commission is 30%, provide 30. Do not enter 0.30 or 30%. ",
    "Please provide the number only. Do not include the currency, commas or any special characters. Only '.' is accepted for decimal values.",
    "Please provide the number only. Do not include the currency, commas or any special characters. Only '.' is accepted for decimal values.",
    "Accepted Values are Yes, No. If 'Yes', the tool will use the auto-calculated baseline OR 0 if the auto-calculated baseline is not available. Hence, before providing 'Yes', please check if the baseline is available, through the UI. And if you enter 'No', you must also enter a custom baseline in column Z. ",
    "Please provide the number only. Do not include the currency, commas or any special characters. Only '.' is accepted for decimal values.",
    "Please provide the number only. If lift is 30%, provide 30. Do not enter 0.30 or 30%. ",
    "Please provide the number only. If lift is 30%, provide 30. Do not enter 0.30 or 30%. ", "Please provide the number only. If lift is 30%, provide 30. Do not enter 0.30 or 30%. ",
    "Please provide a number only without any special characters", "Please provide the number only. If SoV is 30%, provide 30. Do not enter 0.30 or 30%. ",
    "Please provide the number only. If SoV is 30%, provide 30. Do not enter 0.30 or 30%. ", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 200 characters", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 200 characters", "1. This value can be provided only if Placement Status is Booked 2. Accepted Values are Yes, No, N/A", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Accepted Values are Yes, No, N/A- Flat Fee Only", "1. This value can be provided only if Placement Status is Booked 2. Date Format should be 'YYYY-MM-DD HH:MM:SS' (24 Hr)", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Date Format should be 'YYYY-MM-DD HH:MM:SS' (24 Hr)",
    "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters",
    "1. This value can be provided only if Placement Status is Booked 2. Accepted Values are AMOUNT_OFF, BNPL (Buy Now Pay Later), BOGO, COUPON, EVERGREEN, FREE_GIFT, FREE_SHIP, INTRODUCTORY_OFFER, PERCENT_OFF, PRODUCT, PUBLISHER EXCLUSIVE, SUBSCRIPTION",
    "1. This value can be provided only if Placement Status is Booked 2. Max. length of 200 characters", "1. This value can be provided only if Placement Status is Booked 2. Accepted Values are BRAND_CARD_SIGNUP_SPECIFIC, BRAND_CARD_SPECIFIC, COMBO CODE, DEMOGRAPHICS, EMAIL_SIGNUP_REQUIRED, LOCATION_SPECIFIC, LOYALTY_REQUIRED, MEMBERSHIP_REQUIRED, MULTI_BUY,  NEW_CUSTOMER_SPECIFIC, POINT_OF_SALE_SPECIFIC, PRODUCT_SPECIFIC, PROMO_CODE, VANITY, N/A", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 200 characters", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 200 characters", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Accepted Values are Yes, No, N/A", "1. This value can be provided only if Placement Status is Booked 2. Accepted Values are Yes, No, N/A", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Accepted values are Fully Paid, Partially Paid, Not Paid, CPA Increase Only, Make Good - No Cost, N/A", "1. This value can be provided only if Placement Status is Booked 2. Max. length of 500 characters", "1. This value can be provided only if Placement Status is Booked 2. Please provide the number only. Do not include the currency, commas or any special characters. Only '.' is accepted for decimal values.", "1. This value can be provided only if Placement Status is Booked 2. Date Format should be 'YYYY-MM-DD'.",
    "1. This value can be provided only if Placement Status is Booked 2. Max. length of 4000 characters"]

export const TEMPLATE_ROW_SEVEN = ["Sample Data", "Booked", "1113122", "46157", "2023-07-31 00:00:00", "2023-08-15 23:59:59",
    "2023", "Q3", "Aug", "33", "Sample Placement", "Homepage Carousel", "Static", "Yes", "Comped", "No", "Product Launch", "Gold Package - Q3 2023",
    "2", "This is the proposed ad copy", "10", "15", "5000", "2000", "No", "125000", "10", "20", "1", "3000000", "35", "60", "IO#5667771", "N/A",
    "Yes", "PT with 15% commission on SIM_SALE", "15%COMM_SIM_SALE_DURING_PLACEMENT_DAYS", "Yes", "2023-07-15 23:59:59", "Banner with Logo",
    "2023-06-09 13:00:00", "Tiered Offer Details", "AMOUNT_OFF", "500", "BRAND_CARD_SIGNUP_SPECIFIC", "Offer Threshold", "1000", "1323221",
    "June, September & December 2023", "N/A", "N/A", "LIVE AD COPY", "To be provided", "Not yet LIVE", "Not Paid", "3266611", "500", "2023-06-09"
    , "Notes related to Payments"];

export const TEMPLATE_SHEET_NAME = 'Bulk Upload';
export const TEMPLATE_FILENAME = 'Campaigns_Template_For_Bulk_Upload.xlsx';
export const BULK_UPLOAD_LABEL = "Upload Placements";
export const BULK_UPLOAD_HELP_MESSAGE = "Upload placements in bulk in the given file format. Please follow the instructions provided in the template.";
export const BULK_UPLOAD_LINK = "Download sample template";
export const INVALID_PID_ERROR_MESSAGE = 'Invalid Publisher Property ID';
export const ERROR_MESSAGE = "Errors found in {errorRowCount} rows. Please correct the errors and upload the file again.";
export const WARNING_MESSAGE = "Warning found in {warningRowCount} row(s). Please review them, before uploading placements.";
export const BASELINE_WARNING_DETAILS = "Average Daily Revenue Baseline is 0 and " +
    "if you proceed with this value, the performance forecasts will be impacted (projected revenues will be 0)";
export const ADD_FILE = "ADD FILE";
export const ERROR_WARNING_DETAILS_LABEL = "Review errors and warnings";
export const SAME_ADVERTISER_ERROR = "Only one advertiser CID can be present in the file. If you wish to upload placements for multiple advertiser CIDs, please provide multiple files (one for each CID)."
export const INVALID_ADVERTISER_ERROR = "You are not authorised to create placements for the Advertiser CID {advertiserCompanyID}"

export const TEMPLATE_START_ROW_NUMBER = 10
export const BULK_UPLOAD_DATATABLE_COLUMNS_WITH_VALIDATION = [
    {
        field: "isValid",
        headerName: '',
        width: 60,
        cellRenderer: ValidationIcon,
        valueGetter: () => {
            return ""
        }
    },
    ...BULK_UPLOAD_DATATABLE_COLUMNS
]
export const CHECKING_FILE = 'Checking file...';
export const DO_NOT_CLOSE_WINDOW = 'Do not close this window';

export const FILE_SIZE_DEFAULT_MESSAGE = 'File size cannot exceed 50 KB';

export let FILE_SIZE_ERROR_MESSAGE = 'File size exceeds 50 KB';

export const FAILED_PLACEMENT_FILENAME = 'Campaigns_Failed_To_Save_Placements_{timeStamp}.xlsx';
export const FAILED_PLACEMENT_SHEETNAME = "Failed to Save Placements";
export const UPLOADING_PLACEMENTS = 'Uploading placements...'
export const SAVING_PLACEMENT_DO_NOT_CLOSE_WINDOW = 'Do not close this window. Any unsaved changes will be lost.'
export const SUMMARY_POPUP_CONTACT_SUPPORT_MESSAGE = 'Something went wrong. Please try uploading again or download the failed placements and reach out to a support contact, if the problem persists.'
export const UPLOAD_NOTIFICATION_MODAL = "upload-mode";
export const SAVE_PROCESSING_MODAL = 'bulk-upload-save-processing';
export const SAVE_SUMMARY_MODAL = 'bulk-upload-save-summary';
export const YOY_WARNING_DETAILS = "The Publisher Property ID has not generated any revenue for the Advertiser in the " +
    "last 90 days and selecting a non-revenue generating PID will impact the performance reporting";
